import useScrollReset from "@hooks/ScrollHook";
import { NftTabs } from "@components/tabs/NftTabs";
import { TraitsTab } from "./tabs/TraitsTab";
import { Link, useNavigate, useParams } from "react-router-dom";
import { errorPromise, useApi } from "@hooks/ApiHook";
import ActionDropdown from "@components/dropdown/ActionDropdown";
import { PricesModal } from "@components/modals/PricesModal";
import useModal from "@hooks/ModalHook";
import { useEffect, useState } from "react";
import { CoinBadgeV2 } from "@components/CoinBadgeV2";
import useAlert from "@hooks/AlertHook";
import { useWasmX } from "@hooks/WasmXHook";
import { useCoins } from "@contexts/CoinsContext";
import { AssetRequest } from "wasmx";
import { useAccount } from "@contexts/AccountContext";
import { useBaaanggg } from "@hooks/BaaangggHook";
import { querySmartContract } from "@helpers/rpc.helper";
import { useWallet } from "@providers/wallet.provider";
import { sha256 } from "@cosmjs/crypto";
import { fromBase64 } from "@cosmjs/encoding";
import { resolveImageUrl } from "@helpers/image.helper";

export function ItemPage() {
  useScrollReset();
  const alert = useAlert();
  const { id } = useParams();
  const { openModal } = useModal();
  const wasmx = useWasmX();
  const { getCoin } = useCoins();
  const { wallet, address } = useWallet();
  const baaanggg = useBaaanggg();
  const navigate = useNavigate();

  const [prices, setPrices] = useState<{ amount: number; coinId: string }[]>(
    []
  );
  const { data: item } = useApi((api) => api.item.find(id!));
  const { data: traits } = useApi((api) => api.item.itemTraits(id!));
  const { data: collection } = useApi(
    (api) => {
      if (!item) return errorPromise();
      return api.collection.find(item.collectionId);
    },
    [item]
  );
  const { data: mintableDetail, refresh: refreshMintable } = useApi((api) =>
    api.item.listDetail(id!)
  );
  const { data: supply } = useApi((api) => api.item.itemSupply(id!));

  const onList = async () => {
    try {
      if (prices.length === 0)
        throw new Error("Please set the item prices first");
      if (!item || !collection)
        throw new Error("Cannot load item, try to refresh the page");
      if (!wasmx || !wallet)
        throw new Error("Cannot load chain data, try to refresh the page");
      console.log(collection.collectionContract);
      const { voucher } = await querySmartContract(
        collection.collectionContract,
        {
          generate_voucher: {
            voucher: {
              metadata: {
                animation_url: item.animationUrl,
                background_color: item.backgroundColor,
                description: item.description,
                external_url: item.externalUrl,
                identifier: item.id,
                image: item.image,
                image_data: item.imageData,
                name: item.name,
                supply: item.supply,
                token_uri: item.tokenUri,
                youtube_url: item.youtubeUrl,
                attributes: traits?.map((e) => ({
                  trait_type: e.traitType!,
                  value: e.value!,
                  display_type: e.displayType,
                })),
              },
              prices: prices.map<AssetRequest>(({ amount, coinId }) => {
                const coin = getCoin(coinId)!;
                if (coin.isCw20)
                  return {
                    token: {
                      address: coin.cw20Address!,
                      amount: amount.toString(),
                    },
                  };
                else
                  return {
                    coin: {
                      amount: amount.toString(),
                      denom: coin.denom!,
                    },
                  };
              }),
            },
          },
        }
      );
      alert.loading("Sign voucher, please open your terra wallet");
      const result = await signVoucherWithTerraWallet(voucher);

      console.log(result)
      alert.loading("List item to market");
      await baaanggg.item.list({
        itemId: item.id,
        prices: prices.map((e) => ({ ...e, price: e.amount })),
        voucher: result.signature,
      });
      alert.success("Item listed succesfully");
      refreshMintable();
    } catch (e) {
      if (e instanceof Error)
        alert.failed(`Cannot list item, reason: ${JSON.stringify(e)}`);
      else console.error(e);
    }
  };

  async function signVoucherWithTerraWallet(
    voucher: string
  ): Promise<{ signature: string; pubkey: string }> {
    if (!address) throw new Error("Terra wallet not detected");

    const result = await wallet.signArbitrary(voucher);
    console.log(result)
    return {
      signature:result.signature,
      pubkey: result.pubKey,
    };
  }

  const onCancelList = async () => {
    try {
      await baaanggg.item.cancelList(id!);
      alert.success("List cancelled successfully");
      changePrices(
        mintableDetail?.prices?.map((e) => ({
          amount: e.price,
          coinId: e.coinId,
        })) ?? []
      );
      refreshMintable();
    } catch (e) {
      if (e instanceof Error)
        alert.failed(`Cannot cancel list, reason: ${e.message}`);
      else console.error(e);
    }
  };

  const onDelete = async () => {
    try {
      await baaanggg.item.destroy(id!);
      alert.success("Item deleted successfully");
      navigate(`/collection/${collection?.slug}`);
    } catch (e) {
      if (e instanceof Error)
        alert.failed(`Cannot delete item, reason: ${e.message}`);
      else console.error(e);
    }
  };

  useEffect(() => {
    const pricesStr = localStorage.getItem("itemPrices");
    if (pricesStr !== null) setPrices(JSON.parse(pricesStr)[id!] ?? []);
  }, []);

  const changePrices = (prices: { amount: number; coinId: string }[]) => {
    setPrices(prices);

    const pricesStr = localStorage.getItem("itemPrices");
    let localPrices: { [key: string]: any } =
      pricesStr !== null ? JSON.parse(pricesStr) : {};
    localPrices[id!] = prices;

    localStorage.setItem("itemPrices", JSON.stringify(localPrices));
  };

  return (
    <main className="mt-24">
      <section className="relative pb-24 pt-12 lg:py-24">
        <picture className="pointer-events-none absolute inset-0 -z-10 dark:hidden">
          <img
            src="/src/img/gradient_light.jpg"
            alt="gradient"
            className="h-full w-full"
          />
        </picture>
        <div className="container">
          <div className="md:flex md:flex-wrap">
            <figure className="mb-8 md:w-2/5 md:flex-shrink-0 md:flex-grow-0 md:basis-auto lg:w-1/2">
              <img
                src={resolveImageUrl(item?.image)}
                alt="item"
                className="w-full cursor-pointer rounded-2.5xl"
              />
            </figure>

            <div className="md:w-3/5 md:basis-auto md:pl-8 lg:w-1/2 lg:pl-[3.75rem]">
              <div className="mb-3 flex">
                <div className="flex items-center">
                  <Link
                    to={`/collection/${item?.collection?.slug}`}
                    className="mr-2 text-lg font-bold text-jacarta-500   "
                  >
                    {item?.collection?.name}
                  </Link>
                </div>

                <div className="ml-auto flex space-x-2">
                  <div className="flex items-center space-x-1 rounded-xl border border-jacarta-100 bg-white px-4 py-2 dark:border-gray-400 dark:bg-gray-900">
                    <span
                      className="js-likes relative cursor-pointer before:absolute before:h-4 before:w-4 before:bg-cover before:bg-center before:bg-no-repeat before:opacity-0"
                      data-tippy-content="Favorite"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke-width="1.5"
                        className="h-4 w-4 stroke-white"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          d="M15.75 17.25v3.375c0 .621-.504 1.125-1.125 1.125h-9.75a1.125 1.125 0 0 1-1.125-1.125V7.875c0-.621.504-1.125 1.125-1.125H6.75a9.06 9.06 0 0 1 1.5.124m7.5 10.376h3.375c.621 0 1.125-.504 1.125-1.125V11.25c0-4.46-3.243-8.161-7.5-8.876a9.06 9.06 0 0 0-1.5-.124H9.375c-.621 0-1.125.504-1.125 1.125v3.5m7.5 10.375H9.375a1.125 1.125 0 0 1-1.125-1.125v-9.25m12 6.625v-1.875a3.375 3.375 0 0 0-3.375-3.375h-1.5a1.125 1.125 0 0 1-1.125-1.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H9.75"
                        />
                      </svg>
                    </span>
                    <span className="text-sm dark:text-white">
                      {supply?.available}/{supply?.total}
                    </span>
                  </div>

                  {!mintableDetail && (
                    <ActionDropdown
                      items={[
                        {
                          text: "Edit Item",
                          eventHandler: () => navigate(`/item/${id}/edit`),
                        },
                        {
                          text: "Delete",
                          eventHandler: () => onDelete(),
                        },
                      ]}
                    />
                  )}
                </div>
              </div>

              <h1 className="mb-4 font-display text-4xl font-semibold text-jacarta-700 dark:text-white">
                {item?.name}
              </h1>

              <p className="mb-5 dark:text-gray-400">{item?.description}</p>

              <div className="mb-2 flex flex-wrap">
                <div className="mb-4 mr-8 flex">
                  <figure className="mr-4 shrink-0">
                    <a href="user.html" className="relative block">
                      <img
                        src={resolveImageUrl(
                              item?.collection?.owner?.thumbUrl ??
                              "/src/img/avatars/avatar_7.jpg"
                        )}
                        alt="avatar 7"
                        className="w-12 rounded-2lg"
                        loading="lazy"
                      />
                    </a>
                  </figure>
                  <div className="flex flex-col justify-center">
                    <span className="block text-sm text-jacarta-400 dark:text-white">
                      Creator
                    </span>
                    <a href="user.html" className="block text-jacarta-500">
                      <span className="text-sm font-bold">
                        {item?.collection?.owner?.username}
                      </span>
                    </a>
                  </div>
                </div>
              </div>

              {(supply?.available ?? 0) > 0 && (
                <>
                  {!mintableDetail && (
                    <div className="rounded-2lg border border-jacarta-100 bg-white p-8 dark:border-gray-400 dark:bg-gray-900">
                      <div className="flex flex-wrap">
                        {prices.map((price) => (
                          <div className="mb-2.5 mr-2.5" key={price.coinId}>
                            <CoinBadgeV2
                              amount={price.amount}
                              coinId={price.coinId}
                            />
                          </div>
                        ))}

                        <button
                          onClick={() => openModal("prices")}
                          className="group mb-2.5 mr-2.5 inline-flex items-center rounded-lg border border-jacarta-100 bg-white px-4 py-3 hover:border-transparent hover:bg-accent hover:text-white dark:border-jacarta-600 dark:bg-jacarta-800 dark:text-white dark:hover:border-transparent dark:hover:bg-jacarta-500"
                        >
                          <span className="text-2xs font-medium">
                            Edit Prices
                          </span>
                        </button>
                      </div>

                      <button
                        onClick={onList}
                        className="inline-block w-full rounded-full bg-jacarta-500 px-8 py-3 text-center font-semibold text-white transition-all hover:bg-jacarta-600"
                      >
                        List Item
                      </button>
                    </div>
                  )}

                  {mintableDetail && (
                    <div className="rounded-2lg border border-jacarta-100 bg-white p-8 dark:border-gray-400 dark:bg-gray-900">
                      <div className="flex flex-wrap">
                        {mintableDetail.prices?.map((price) => (
                          <div className="mb-2.5 mr-2.5" key={price.coinId}>
                            <CoinBadgeV2
                              amount={price.price}
                              coinId={price.coinId}
                            />
                          </div>
                        ))}
                      </div>

                      <button
                        onClick={onCancelList}
                        className="inline-block w-full rounded-full bg-jacarta-500 px-8 py-3 text-center font-semibold text-white transition-all hover:bg-jacarta-600"
                      >
                        Cancel List
                      </button>
                    </div>
                  )}
                </>
              )}
            </div>
          </div>

          <div className="scrollbar-custom mt-14 overflow-x-auto rounded-lg">
            <div className="min-w-fit">
              <NftTabs
                items={{
                  Traits: traits && <TraitsTab traits={traits} />,
                }}
              />
            </div>
          </div>
        </div>
      </section>

      <PricesModal
        onChange={(prices) =>
          changePrices(
            Object.entries(prices).map(([coinId, amount]) => ({
              coinId,
              amount,
            }))
          )
        }
        prices={prices.reduce(
          (prev, curr) => ({ ...prev, [curr.coinId]: curr.amount }),
          {}
        )}
      />
    </main>
  );
}
